import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import SqlImportModel from 'cio/models/sql-import';
import ApiErrorsService from 'cio/services/api-errors';
import AuthService from 'cio/services/auth';

export default class SqlImportsImportController extends Controller {
  queryParams = ['confirmingStatusChange'];

  tooltipText = `You must have Workspace manager permissions (or greater) to manage syncs. Contact your workspace admin to increase your permissions.`;

  declare model: SqlImportModel;

  @service apiErrors!: ApiErrorsService;
  @service auth!: AuthService;

  @tracked confirmingStatusChange: true | null = null; // initialize with "null" to avoid empty "confirmingStatusChange=" URL param value
  @tracked confirmingDelete = false;

  @action
  toggleConfirmStatusChange() {
    this.confirmingStatusChange = this.confirmingStatusChange ? null : true;
  }

  @action
  toggleConfirmDelete() {
    this.confirmingDelete = !this.confirmingDelete;
  }

  @action
  async updateAttribute(attr: Extract<SqlImportModel, 'name' | 'description'>, value: string) {
    this.model.set(attr, value);

    try {
      await this.model.save();
    } catch (err) {
      this.apiErrors.report(err);
      throw err;
    }
  }

  @action
  discardChanges() {
    this.model.rollbackAttributes();
  }
}

declare module '@ember/controller' {
  interface Registry {
    'sql-imports.import': SqlImportsImportController;
  }
}
